import { stylesheet } from 'typestyle';

import { List, Item } from '@components/productDetail/PageFooter.jsx';

import { linkBlueText } from '@src/styles/general';

const liveChatIcon = '/images/lumera_difference_icons/live_chat.png';
const phoneIcon = '/images/lumera_difference_icons/phone.png';
const emailIcon = '/images/lumera_difference_icons/email.png';

const css = stylesheet({
  chatButton: {
    $nest: {
      '&:hover': {
        cursor: 'pointer',
        color: linkBlueText,
        textDecoration: 'underline'
      }
    }
  }
});

const simulateClick = function(elem) {
  // Create our event (with options)
  var evt = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window
  });
  // If cancelled, don't dispatch our event
  var canceled = !elem.dispatchEvent(evt);
};

function NeedHelp() {
  const handleChatKeypress = (e: SyntheticKeyboardEvent<HTMLSpanElement>) => {
    if (e.key === 'Enter') {
      simulateClick(e.target);
    }
  };
  return (
    <div>
      <p>
        <strong className='blue-text'>Need Help?</strong> Ask a consultant for a
        second opinion.
      </p>
      <List inline>
        <Item noUnderline style={{ marginRight: 25 }}>
          <span
            role='button'
            className={`chat-link ${css.chatButton}`}
            tabIndex={0}
            onKeyPress={handleChatKeypress}
          >
            <img src={liveChatIcon} style={{ marginRight: 10 }} />
            Live Chat
          </span>
        </Item>
        <Item noUnderline style={{ marginRight: 25 }}>
          <a href='tel:18886586372'>
            <img src={phoneIcon} style={{ marginRight: 15 }} />
            888-658-6372
          </a>
        </Item>
        <Item noUnderline>
          <a href='mailto:CustomerService@LumeraDiamonds.com'>
            <img src={emailIcon} style={{ marginRight: 14 }} />
            Email
          </a>
        </Item>
      </List>
    </div>
  );
}

export default NeedHelp;
